import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/logo & badge images/logo-white.png" alt="Shikhar Dhara Logo" />
            <div className="logo-text">
              <span className="logo-name">Shikhar Dhara</span>
              <span className="logo-tagline">Pure Water • Fresh Juice</span>
            </div>
          </Link>

          <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              <li>
                <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/products" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
                  Our Products
                </NavLink>
              </li>
              <li>
                <NavLink to="/manufacturing" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
                  Manufacturing
                </NavLink>
              </li>
              <li>
                <NavLink to="/distributor" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
                  Distributor
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
                  Contact
                </NavLink>
              </li>
              <li className="mobile-only-btn">
                 <a href="mailto:info@shikhardhara.com" className="btn btn-primary" onClick={() => setIsMenuOpen(false)}>
                    Get Quote
                 </a>
              </li>
            </ul>
          </nav>
          
          {/* Mobile Backdrop */}
          {isMenuOpen && <div className="menu-backdrop" onClick={() => setIsMenuOpen(false)}></div>}

          <div className="header-actions">
            <a 
              href="mailto:info@shikhardhara.com" 
              className="btn btn-primary header-inquiry-btn"
            >
              Get Quote
            </a>
          </div>

          <button 
            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} 
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger"></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
